<template>
  <div class="">
    <Card class="">
      <template #title> Yeni Tarif </template>
      <template #content>

        <div class=" grid">
          <div class="col-12">
            <Panel class="pb-5">

              <div class=" grid">
                <div class="col-3">
                  <div class="formgrid grid">
                    <div class="field col md:col-12">
                      <label for="TarifAd" class="font-bold block">Tarif Adı</label>
                      <InputText id="TarifAd" type="text" v-model="TarifAd" class="text-base text-color w-full"
                        :invalid="this.Valid.TarifAd" />
                    </div>
                    <div class="field col md:col-12">
                      <label for="Birim" class="font-bold block">Birim</label>
                      <Select name="Birim" v-model="pBirim" :options="BirimListesi" optionLabel="Ad"
                        optionValue="Birim_rowid" checkmark :highlightOnSelect="true" fluid
                        :invalid="this.Valid.pBirim" />
                    </div>
                    <div class="field col md:col-12">
                      <label for="Kalori" class="font-bold block">Kalori</label>
                      <InputNumber v-model="Kalori" showButtons buttonLayout="horizontal" :step="1" :min="0" :max="9999"
                        :invalid="this.Valid.Kalori" fluid class="text-base text-color w-full" suffix=" kcal">
                        <template #incrementbuttonicon>
                          <span class="pi pi-plus" />
                        </template>
                        <template #decrementbuttonicon>
                          <span class="pi pi-minus" />
                        </template>
                      </InputNumber>
                    </div>
                  </div>
                </div>
                <div class="col-9">
                  <label class="font-bold block mb-2">Detaylar</label>
                  <Editor v-model="TarifTarif" style="height:30vh; width:100%" />
                </div>
              </div>
            </Panel>
          </div>

          <div class="col-12">
            <IslemYapiliyor v-if="IslemYapiliyor" />
          </div>
          <div class="col-12 flex justify-content-end flex-wrap">
            <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
              @click="this.handleClick()" autofocus :disabled="IslemYapiliyor" v-if="!IslemYapiliyor" />
          </div>
        </div>

      </template>
    </Card>
  </div>
</template>

<script>
import GlobalServis from "../../../../../services/GlobalServis";

export default {
  data() {
    return {
      IslemYapiliyor: false,
      BirimListesi: [],

      TarifAd: "",
      pBirim: 0,
      Kalori: "",
      TarifTarif: "",
      //--------------
      // Validation Elements
      Valid: {
        TarifAd: false,
        pBirim: false,
        Kalori: false,
        TarifTarif: false,
      }
    };
  },
  methods: {
    handleClick() {
      if (this._FormCheck()) { return; }
      this.IslemYapiliyor = true;


      let data = {
        TarifAd: this.TarifAd,
        pBirim: this.pBirim,
        Kalori: this.Kalori,
        TarifTarif: this.TarifTarif,
      };

      GlobalServis.GlobalServis("POST", "SetTarif", data).then((res) => {
        if (res.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Başarılı",
            detail: "Tarif oluşturulmuştur",
            life: 3000,
          });
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
        this.IslemYapiliyor = false;
        this.$router.push({ path: "/Diyetisyen/TarifListesi" });
      });
    },
    _GetBirimListesi() {
      GlobalServis.GlobalServis("GET", "GetBirimListesi", "").then((res) => {
        if (res.status == 200) {
          this.BirimListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _ResetForm() {
      this.TarifAd = "";
      this.pBirim = 0;
      this.Kalori = "";
      this.TarifTarif = "";
    },
    _FormCheck() {
      let Check = false;
      if (this.TarifAd === "") {
        this.Valid.TarifAd = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Tarif adı girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.TarifAd = false; Check = false; }

      if (this.pBirim === 0) {
        this.Valid.pBirim = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Birim seçin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.pBirim = false; Check = false; }

      if (this.Kalori === "") {
        this.Valid.Kalori = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Kalori girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.Kalori = false; Check = false; }


      if (this.TarifTarif === "") {
        this.Valid.TarifTarif = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Tarif girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.TarifTarif = false; Check = false; }


      return Check;
    },
  },
  mounted() {
    this._GetBirimListesi();
  },
  components: {
  },
};
</script>